// src/helpers/formatters.js
import moment from 'moment';

export function formatDate(value, format = 'DD/MM/YYYY') {
  if (!value) return '—';
  return moment(value).format(format);
}

export function formatDateTime(value) {
  if (!value) return '—';
  return moment(value).format('DD/MM/YYYY HH:mm');
}

export function formatRelative(value) {
  if (!value) return '—';
  return moment(value).fromNow();
}

export function formatCurrency(value, suffix = ' pts') {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString('fr-FR') + suffix;
}

export function formatNumber(value) {
  if (value === null || value === undefined) return '—';
  return Number(value).toLocaleString('fr-FR');
}

export function formatBoolean(value) {
  if (value === null || value === undefined) return '—';
  return value ? 'Oui' : 'Non';
}

/**
 * Calcule le seuil de stock (objectif + bonus%) pour affichage côté front.
 * Doit rester aligné avec NewTipGainCalculatorService::threshold().
 */
export function calculateThreshold(objective, bonusPercentage) {
  if (!objective || objective <= 0) return null;
  return Math.round(objective * (1 + (bonusPercentage || 0) / 100));
}
